import { usePathname } from "@-/com.npmjs.expo-router";
import { useSupportSettingsPageNavigator } from "@-/dev.improve.haniverse.routes.nav.app.settings.support.navigator";
import { HeaderScrollView } from "@-/dev.improve.haniverse.components.ui.header-scroll";
import { LegalAgreementNotice } from "@-/dev.improve.haniverse.components.legal";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { getAppVersionLabel } from "@-/dev.improve.haniverse.lib.app.version";
import { View } from "@-/com.npmjs.react-native";

export function AboutSettingsPageContent() {
  const pathname = usePathname();
  const navigator = useSupportSettingsPageNavigator();
  const inSupport = pathname.startsWith("/support/");
  return (
    <HeaderScrollView
      className="flex-1 bg-background"
      contentContainerClassName="gap-6 px-5 py-6"
      contentInsetAdjustmentBehavior="automatic"
    >
      <View className="gap-3">
        <Text className="text-left text-foreground" variant="h1">
          Haniverse
        </Text>
        <Text selectable={true} variant="muted">
          Copyright © 2026 ImproveLabs. All rights reserved.
        </Text>
        <Text selectable={true} variant="lead">
          The fastest way to learn Chinese characters.
        </Text>
        <Text selectable={true} variant="muted">
          Version {getAppVersionLabel()}
        </Text>
      </View>

      <View className="gap-3">
        <Text variant="h3">About the App</Text>
        <Text className="text-muted-foreground" selectable={true} variant="p">
          Haniverse helps you learn and review Chinese characters through structured lessons,
          searchable character cards, and spaced repetition. It is designed to make each study
          session feel manageable while keeping the details that matter close at hand: meanings,
          pinyin, examples, components, and review history.
        </Text>
        <Text className="text-muted-foreground" selectable={true} variant="p">
          Use Haniverse to discover new characters, revisit cards when they are due, and follow your
          progress as your deck grows.
        </Text>
      </View>

      <LegalAgreementNotice
        leadIn="By using Haniverse, you agree to Haniverse's "
        onPrivacyPress={inSupport ? () => navigator.navigate.mutate("privacy") : undefined}
        onTermsPress={inSupport ? () => navigator.navigate.mutate("terms") : undefined}
      />
    </HeaderScrollView>
  );
}
